module.exports = __webpack_public_path__ + "static/ubuntu-regular-03c831f7b9cdf705e0565484d568b6f6.eot";